/**
 * Finds the dollar amount inside the announcement bar's text (e.g. "FREE SHIPPING ON ORDERS
 * $250+ WORLDWIDE") and rewrites it to the buyer's own currency, so it always matches the
 * free-shipping milestone tier (see snippets/asd-announcement-currency.liquid for why this can't
 * be done in Liquid, and the currency-conversion rule, which mirrors assets/asd-milestone-bar.js).
 *
 * Runs once at load - the announcement bar's amount doesn't change with the cart, only with the
 * buyer's currency, which is fixed for the page's lifetime (there's no manual currency switcher).
 */
(function () {
  const DOLLAR_AMOUNT = /\$[\d,]+(?:\.\d+)?\+?/;
  const CAD_PER_USD = 1.37; // approximate, fixed - see assets/asd-milestone-bar.js

  function convert(shopCurrencyCents) {
    const active = window.Shopify?.currency?.active;
    if (!active || active === 'CAD' || active === 'USD') return shopCurrencyCents;

    const cadToActive = Number(window.Shopify?.currency?.rate);
    if (!Number.isFinite(cadToActive) || cadToActive <= 0) return shopCurrencyCents;

    const usdToActive = cadToActive * CAD_PER_USD;
    return Math.round((shopCurrencyCents * usdToActive) / 100) * 100; // nearest whole unit
  }

  function money(cents) {
    const value = cents / 100;
    const whole = Number.isInteger(value);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2,
      }).format(value);
    } catch {
      return `$${whole ? value : value.toFixed(2)}`;
    }
  }

  function run() {
    const data = document.getElementById('asd-announcement-currency-data');
    const rawAmount = Number(data?.dataset.amountShopCurrency);
    if (!Number.isFinite(rawAmount) || rawAmount <= 0) return;

    const converted = convert(rawAmount);
    const formatted = money(converted) + '+';

    document.querySelectorAll('.announcement-bar__text').forEach((el) => {
      if (DOLLAR_AMOUNT.test(el.textContent)) {
        el.textContent = el.textContent.replace(DOLLAR_AMOUNT, formatted);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
